
export default {
	name: "NormalPage",
	data() {
		return {
			title: "Porto Design Biennale",
			titleRendered: null,
		}
	},
	created() {
		this.titleSplit();
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	mounted() {
		this.logoVar();
	},
	methods: {
		titleSplit() {
			this.titleRendered = this.title.split('');
		},
		logoVar() {
			let logo = document.getElementsByClassName("logo");
			console.log("Logo", logo[0])
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/normal/normal.page.js